// delLists/approvedLists/actions.js

import { getDelLists } from "../../../api/DelApi";
import { approvedInitialState } from "./delListsApprovedListsState";
import { filtersInitialState } from "../../shared/filters/filtersState";
export const makeApprovedActions = (set, get) => ({
  setApprovedPage: ({ currentPage, pageSize }) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        approved: { ...s.delLists.approved, currentPage, pageSize },
      },
    })),

  setApprovedPageSize: (pageSize) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        approved: { ...s.delLists.approved, pageSize, currentPage: 1 },
      },
    })),

  setSelectedApproved: (approved) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        approved: { ...s.delLists.approved, selectedApproved: approved },
      },
    })),

  toggleSelectedApproved: (approvedId) =>
    set((s) => {
      const current = s.delLists.approved.selectedApprovedIds || [];
      const exists = current.includes(approvedId);
      const next = exists
        ? current.filter((i) => i !== approvedId)
        : [...current, approvedId];
      return {
        delLists: {
          ...s.delLists,
          approved: { ...s.delLists.approved, selectedApprovedIds: next },
        },
      };
    }),

  setSelectedApprovedIds: (approvedIds) =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        approved: { ...s.delLists.approved, selectedApprovedIds: approvedIds },
      },
    })),

  clearSelectedApprovedIds: () =>
    set((s) => ({
      delLists: {
        ...s.delLists,
        approved: { ...s.delLists.approved, selectedApprovedIds: [] },
      },
    })),

  resetApproved: () =>
    set((s) => ({
      delLists: { ...s.delLists, approved: approvedInitialState },
    })),

  fetchApprovedPage: async (employeeId, overrideFilters) => {
    const {
      delLists: {
        approved: { currentPage, pageSize, filters, tableType },
      },
    } = get();
    const activeFilters = overrideFilters || filters || filtersInitialState();

    set((s) => ({
      delLists: {
        ...s.delLists,
        approved: { ...s.delLists.approved, loading: true, error: null },
      },
    }));

    try {
      const r = await getDelLists(
        employeeId,
        tableType,
        currentPage,
        pageSize,
        activeFilters
      );
      set((s) => ({
        delLists: {
          ...s.delLists,
          approved: {
            ...s.delLists.approved,
            loading: false,
            items: r.del_list,
            totalCount: r.total_count,
            needsUpdate: false,
            selectedApproved: null,
          },
        },
      }));
    } catch (err) {
      console.error("Failed to fetch approved page:", err);
      set((s) => ({
        delLists: {
          ...s.delLists,
          approved: {
            ...s.delLists.approved,
            loading: false,
            error: err.message,
          },
        },
      }));
    }
  },

  // Downloads (mirror Submits)
  downloadApprovedPdfs: async (ids) => {
    const { loadingActions, notificationActions, delListsActions } = get();
    const list = Array.isArray(ids) ? ids : ids ? [ids] : [];
    if (list.length === 0) {
      notificationActions.showNotification({
        type: "error",
        title: "No DELs Selected",
        message: "Select at least one approved DEL to download.",
      });
      return;
    }
    try {
      loadingActions.showLoading(
        list.length > 1 ? "Downloading DEL PDFs..." : "Downloading DEL PDF..."
      );
      // Reuse submit download since backend endpoint is shared
      await delListsActions.downloadSubmitPdfs(list);
      notificationActions.showNotification({
        type: "success",
        title: "Download Started",
        message:
          list.length > 1
            ? "Your ZIP is downloading."
            : "Your PDF is downloading.",
      });
    } catch (err) {
      console.error("Failed to download Approved DEL PDF(s):", err);
      notificationActions.showNotification({
        type: "error",
        title: "Download Failed",
        message: "Could not download the requested DEL PDF(s).",
      });
    } finally {
      loadingActions.hideLoading();
    }
  },
});
